export const en = {
    'audience-and-metrika': 'Yandex.Audience and Yandex.Metrica',
    copied: 'Copied',
    'copy-error': 'Error copying',
    'copy-link': 'Copy ad group settings to clipboard',
    ots: 'OTS',
    'predictor-settings': 'Ad group settings',
    'reach-title': 'Impressions',
    'reach-title-ots': 'Reach'
};
